import { createContext, useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const AdminThemeContext = createContext(null);

const resolveInitial = () => {
  if (typeof window === "undefined") return "dark";
  const stored = localStorage.getItem("admin_theme");
  if (stored === "light" || stored === "dark") return stored;
  return window.matchMedia?.("(prefers-color-scheme: light)").matches ? "light" : "dark";
};

export const AdminThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(resolveInitial);
  const location = useLocation();

  useEffect(() => {
    localStorage.setItem("admin_theme", theme);
  }, [theme]);

  useEffect(() => {
    const isAdmin = location.pathname.startsWith("/admin");
    if (isAdmin) {
      document.documentElement.setAttribute("data-admin-theme", theme);
    } else {
      document.documentElement.removeAttribute("data-admin-theme");
    }
  }, [theme, location.pathname]);

  const toggle = () => setTheme(t => (t === "dark" ? "light" : "dark"));

  return (
    <AdminThemeContext.Provider value={{ theme, toggle, setTheme }}>
      {children}
    </AdminThemeContext.Provider>
  );
};

export const useAdminTheme = () => {
  const ctx = useContext(AdminThemeContext);
  if (!ctx) return { theme: "dark", toggle: () => {}, setTheme: () => {} };
  return ctx;
};
